export let colors = ['rgb(0,255,164)', 'rgb(166,104,255)'];
